import { ID_ACCOUNTED, ID_SENT, ID_TO_SEND, ID_UNACCOUNTED } from "../constants/PayableInvoicesStatuses";
import ColouredChip from "../../../component/ColouredChip";
import { COLOR_ACCOUNTED, COLOR_SENT, COLOR_TO_SEND, COLOR_UNACCOUNTED } from "../constants/PayableInvoicesColors";
import * as React from "react";

export function showStatusColumn(status: string) {
    switch (status) {
        case ID_TO_SEND: {
            return {
                component: () => <ColouredChip name={ID_TO_SEND} color={COLOR_TO_SEND}/>
            };
        }
        case ID_SENT: {
            return {
                component: () => <ColouredChip name={ID_SENT} color={COLOR_SENT}/>
            };
        }
        case ID_ACCOUNTED: {
            return {
                component: () => <ColouredChip name={ID_ACCOUNTED} color={COLOR_ACCOUNTED}/>
            };
        }
        case ID_UNACCOUNTED: {
            return {
                component: () => <ColouredChip name={ID_UNACCOUNTED} color={COLOR_UNACCOUNTED}/>,
            };
        }
    }
}